/**
 * Styles pour le bouton de chat principal
 * Design amélioré pour ressembler à ChatSystem avec icône Phosphor
 */
export const CHAT_BUTTON_STYLES = `
  /* Widget button (EnhancedChatWidget) */
  .ringado-chat-button {
    position: relative;
    width: 64px;
    height: 64px;
    border-radius: 50%;
    background: white;
    border: 2px solid #e5e7eb;
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
    animation: ringado-wave-auto 4s ease-in-out infinite;
    z-index: 1;
  }

  .ringado-chat-button:hover {
    background: #f9fafb;
    border-color: #9ca3af;
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
    transform: scale(1.05);
  }

  .ringado-chat-button::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(to right, #3b82f6, #8b5cf6);
    border-radius: 50%;
    filter: blur(12px);
    opacity: 0.15;
    transform: scale(1.2);
    animation: pulse 3s ease-in-out infinite;
    z-index: -1;
  }

  /* Icône Phosphor hand-waving */
  .ringado-chat-button .chat-icon {
    width: 28px;
    height: 28px;
    z-index: 2;
    position: relative;
    transition: all 0.3s ease;
    color: #374151;
  }

  .ringado-chat-button:hover .chat-icon {
    animation: ringado-wave-on-hover 0.6s ease-in-out;
    color: #111827;
    transform: scale(1.1);
  }

  /* SVG pour l'icône hand-waving de Phosphor */
  .ringado-chat-button .chat-icon svg {
    width: 100%;
    height: 100%;
    fill: currentColor;
  }

  /* Hide widget when modal is open */
  .ringado-widget.modal-open .ringado-chat-button {
    opacity: 0;
    transform: scale(0.8);
    pointer-events: none;
  }
`;
